import React from 'react';
import { motion } from 'framer-motion';
export function Preview() {
  return <section className="bg-white py-8 sm:py-28 overflow-hidden" data-id="element-216">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-217">
        <div className="text-center max-w-3xl mx-auto mb-6 sm:mb-16" data-id="element-218">
          <h2 className="text-[10px] sm:text-sm font-semibold tracking-wide text-blue-600 uppercase mb-1.5 sm:mb-3" data-id="element-219">
            VISTA PREVIA
          </h2>
          <p className="text-xl font-bold tracking-tight text-slate-900 sm:text-4xl mb-2 sm:mb-4" data-id="element-220">
            Explorá el interior del Megapack
          </p>
          <p className="text-xs sm:text-lg text-slate-600" data-id="element-221">
            Conocé la calidad de nuestros protocolos, plantillas y checklists
            antes de tu próxima consulta.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative mx-auto max-w-4xl flex justify-center" data-id="element-222">
          <div className="absolute -inset-4 bg-gradient-to-r from-blue-100 to-teal-100 rounded-[2rem] sm:rounded-[3rem] blur-2xl opacity-50 -z-10" data-id="element-223"></div>

          {/* Tablet Frame */}
          <div className="relative bg-slate-900 rounded-[2rem] sm:rounded-[3rem] p-3 sm:p-6 shadow-2xl ring-1 ring-slate-800 max-w-[280px] sm:max-w-2xl w-full" data-id="element-224">
            {/* Camera dot */}
            <div className="absolute top-1.5 sm:top-3 left-1/2 -translate-x-1/2 w-1.5 h-1.5 sm:w-2 sm:h-2 bg-slate-800 rounded-full" data-id="element-225"></div>

            {/* Screen */}
            <div className="relative bg-white rounded-xl sm:rounded-2xl overflow-hidden aspect-[3/4] sm:aspect-video ring-1 ring-slate-800/50" data-id="element-226">
              <video src="https://cdn.magicpatterns.com/uploads/mRp8Uaab2ftG4y9bDWB1fY/Screen%20recording%20web%20pediatria.mov" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-227" />
            </div>

            {/* Home button (iPad style) */}
            <div className="absolute bottom-1 sm:bottom-2 left-1/2 -translate-x-1/2 w-8 h-1 sm:w-16 sm:h-1.5 bg-slate-800 rounded-full" data-id="element-228"></div>
          </div>
        </motion.div>
      </div>
    </section>;
}